module.exports = __webpack_public_path__ + "static/img/DCR-Selected.3dedbe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/DCR-Selected.png
// module id = 1568
// module chunks = 0